<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page="20"
      class="elevation-1"
      :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
      no-data-text="No hay contratos para mostrar"
      sort-by="rejectionRate"
      :sort-desc="true"
    >
      <template v-slot:top>
        <v-row class="px-4 pt-4 pb-2 align-center justify-space-between">
          <v-col cols="12" md="6" class="my-0 py-0">
            <v-text-field
              v-model="search"
              label="Buscar empresa o ID"
              dense hide-details outlined clearable
              append-icon="mdi-magnify"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.producto="{ item }">
        {{ item.producto || '—' }}
      </template>

      <template v-slot:item.rejectionRate="{ item }">
        <v-chip v-if="item.rejectionRate !== null" small :color="rejectionColor(item.rejectionRate)" class="white--text font-weight-bold">
          {{ item.rejectionRate }}%
        </v-chip>
        <span v-else class="grey--text">—</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip v-if="can('companies:view')" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon small
              v-bind="attrs"
              v-on="on"
              @click="viewContract(item)"
            >
              <v-icon small>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>Ver detalle de empresa</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-snackbar v-model="showSnackbar" :color="snackbarColor" timeout="3000" top>
      {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import RefundMetricsService from '@/services/refund-metrics.service';
import { utilsMixin } from '@/mixins/utilsMixin';
import { can } from '@/utils/permissions';

export default {
  name: 'RefundsByContractTable',
  mixins: [utilsMixin],

  props: {
    fromDate: { type: String, default: null },
    toDate: { type: String, default: null },
  },

  data() {
    return {
      loading: false,
      rows: [],
      search: '',
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: 'green',
    };
  },

  watch: {
    fromDate() {
      this.fetchData();
    },
    toDate() {
      this.fetchData();
    },
  },

  computed: {
    headers() {
      return [
        { text: 'ID',                 value: 'codigo',       sortable: true },
        { text: 'Empresa',            value: 'company',      sortable: true },
        { text: 'Producto',           value: 'producto',     sortable: true },
        { text: 'Total solicitudes',  value: 'total',        sortable: true },
        { text: 'En proceso',         value: 'inProcess',    sortable: true },
        { text: 'Tasa de rechazo',    value: 'rejectionRate', sortable: true },
        { text: 'Acciones',          value: 'actions',       sortable: false, align: 'center' },
      ];
    },

    items() {
      const term = (this.search || '').trim().toLowerCase();
      if (!term) return this.rows;
      return this.rows.filter(
        (r) =>
          (r.company || '').toLowerCase().includes(term) ||
          (r.codigo || '').toLowerCase().includes(term)
      );
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    can,
    rejectionColor(pct) {
      if (pct >= 40) return 'red';
      if (pct >= 20) return 'orange';
      return 'green';
    },
    async fetchData() {
      this.loading = true;
      const res = await RefundMetricsService.getByContract({
        fromDate: this.fromDate,
        toDate: this.toDate,
      });
      if (res.status === 'ok') {
        this.rows = res.data.data;
      } else {
        this.rows = [];
        this.showErrorSnackbar('Ocurrió un error al cargar los contratos');
      }
      this.loading = false;
    },
    viewContract(item) {
      this.$router.push(
        `/business-relationships/companies/${item.companyId}?contratoId=${item.id}`
      );
    },
  },
};
</script>
